import { createStyledContext } from "@tamagui/core";
const GroupContext = createStyledContext({
  layout: "column"
});
export { GroupContext };
//# sourceMappingURL=Group.context.mjs.map
